import { Component,OnDestroy, ViewChild,Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router,  ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { HttpHeaders} from "@angular/common/http";
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';
import { User,QueryStringParameter,  DynamicPage} from '../../models/data.types';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription'

@Component({
  entryComponents: [DynamicPageComponent],
  templateUrl: './version.component.html'
})
export class VersionComponent {
  
    sub: any;
    pagename: string;
    page: DynamicPage = new DynamicPage();
    pageTitle : string = "";
    private subscriptions = new Subscription();

  @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

  constructor( private renderer: Renderer2,private route: ActivatedRoute, 
    private router: Router,
    private apiService: ApiService,
    private titleService: Title) { }

  ngOnInit() {

    this.subscriptions =  Observable.combineLatest(this.route.params, this.route.queryParams, 
      (params, qparams) => ({ params, qparams })).subscribe( ap =>   { 
    
          this.pagename = ap.params['id'];

          return this.apiService.get<DynamicPage>('pages/GetPageVersionByRouteAndVersion/' + this.pagename +'?version='+ap.qparams["version"]).then(response => {

            let currentUser : User;
            currentUser = JSON.parse(localStorage.getItem('currentUser'));

            if (this.page != null )
            {
                      
              let queryStringparams: QueryStringParameter[] = [];
              
              let pArray = Reflect.ownKeys(ap.qparams);
              
              pArray.forEach(element => {
                        let qsp = new QueryStringParameter();
                        qsp.Name = element.toString();
                        qsp.Value = Reflect.get(ap.qparams, element.toString());
                        queryStringparams.push(qsp);
                      });
              
              this.page = response;
              
              this.dynamicPage.addComponent(this.page,queryStringparams,true);
              
              this.pageTitle =this.page.Title;
              
              this.titleService.setTitle(this.pageTitle);
              
              if(queryStringparams.find(x => x.Name == "portal" || x.Name == "title") == null)
                  {
                      this.page = null;
                  }
          }

        });
        });

        return this.pageTitle;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/version/version.component.ts